/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'account-badge-outline': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M14 20H4v-3c0-2.7 5.3-4 8-4 1.5 0 3.9.4 5.7 1.3-.8.3-1.4.7-2 1.2-1.1-.4-2.4-.6-3.7-.6-3 0-6.1 1.5-6.1 2.1v1.1h8.3c-.1.4-.2.9-.2 1.4v.5m9-.5c0 1.9-1.6 3.5-3.5 3.5S16 21.4 16 19.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2C9.8 4 8 5.8 8 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"/>'
  }
})
